import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import Typography from "@material-ui/core/Typography";
import { Link, Link as RouterLink, withRouter } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useHistory } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";
import LoginRegisterTabs from "../LoginRegisterTabs";
import ForgetPassword from "./ForgetPassword";
import { useCookies } from "react-cookie";
import { InputAdornment } from "@material-ui/core";
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import { makeStyles } from "@material-ui/core";
import apiHelper from "../../utils/apiHelper";
import { getTodayWithoutTime } from "../../utils/helper";

const schema = yup.object().shape({
  member_id: yup.string(),
  password: yup.string(),
});

const Overlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
  top: 0;
  left: 0;
`;

const useStylesAll = makeStyles((theme) => ({
  pageContainer: {
    position: "absolute",
    width: "100%",
    fontFamily: "Poppins",
  },
  container: {
    width: "85%",
    backgroundColor: "#FFFFFF",
    margin: "30px auto",
    color: "#000000",
    padding: "10px 15px",
    [theme.breakpoints.up("md")]: {
      margin: "20vh auto",
      width: 625,
      padding: "30px",
    },
    "@media (max-height:750px)": {
      marginTop: "180px",
    },
  },
  btn: {
    marginTop: "10px",
  },
  highlight: {
    color: "#962013",
    textDecoration: "none",
  },
  forget: {
    color: "#727272",
    textDecoration: "none",
    position: "absolute",
    right: 0,
    top: "-3px",
    fontSize: "14px",
    "&:hover": {
      color: "rgba(153, 153, 153, 0.8)",
      cursor: "pointer"
    },
  },
  reminderBox: {
    width: "80%",
    maxWidth: "1140px",
    backgroundColor: "#FFFFFF",
    margin: "30px auto",
    color: "#000000",
    padding: "20px 20px 40px",
    [theme.breakpoints.up("md")]: {
      margin: "20vh auto",
      width: "75%",
      padding: "30px",
      padding: "30px 30px 50px",
    },
  },
  smallBtn: {
    width: "100%",
    marginBottom: "0px",
    [theme.breakpoints.up("md")]: {
      width: "unset",
      marginRight: "10px",
      minWidth: "250px",
    },
  },
}));

const defaultFormValues = {
  member_id: "",
  password: "",
};

function LoginPage(props) {
  const { t, i18n } = useTranslation("login");
  const classes = useStylesAll();
  const [isDisabled, setIsDisabled] = React.useState(true);
  const [isEndSoon, setIsEndSoon] = React.useState(false);
  const [isExpired, setIsExpired] = React.useState(false);
  const [isForget, setIsForget] = React.useState(false);
  const [defaultValues, setDefaultValues] = React.useState(defaultFormValues);
  const [exDate, setExDate] = React.useState("");
  const [username, setUsername] = React.useState("");
  const [discount, setDiscount] = React.useState("");
  const [cookies, setCookie, removeCookie] = useCookies();
  const [showPassword, setShowPassword] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const history = useHistory();

  const {
    control,
    register,
    handleSubmit,
    watch,
    getValues,
    setValue,
    reset,
    formState,
  } = useForm({
    defaultValues: React.useMemo(() => defaultValues, [defaultValues]),
    resolver: yupResolver(schema),
  });

  const onSubmit = async (value) => {
    // setLoading(true);
    // purge date and time
    const { member_id, password } = value;
    setErrorMessage("");
    if (member_id !== "" && password !== "") {
      try {
        const json = {
          password: password,
          username: member_id,
        };
        apiHelper
          .login(json)
          .then(function (response) {
            setCookie("token", response.data.token, { path: "/", domain: process.env.REACT_APP_HKIFF_DOMAIN || "cloud.udev.hk" });
          })
          .catch(function (error) {
            console.log("error");
            console.log(error);
            setErrorMessage({ all: true, password: "invalidmembership" });
          });
      } catch (e) {
        console.log(e);
      }
    } else {
      if (member_id === "" && password === "") {
        setErrorMessage({
          memberId: "cineclubiderror",
          password: "passworderror",
        });
      } else if (member_id === "") {
        setErrorMessage({ memberId: "cineclubiderror" });
      } else if (password === "") {
        setErrorMessage({ password: "passworderror" });
      }
    }
  };

  useEffect(() => {
    if (props.isMember && discount === "") {
      history.push("/" + i18n.language + "/profile");
    }
  }, []);

  useEffect(() => {
    console.log(process.env.REACT_APP_HKIFF_DOMAIN);
    if (cookies.token) {
      try {
        apiHelper
          .getMemberInfo(cookies.token)
          .then(function (response) {
            setCookie("firstName", response.data.firstName, { path: "/" });
            setCookie("lastName", response.data.lastName, { path: "/" });

            if(response.data.expiryDate == null){
              setCookie("expiryDate", "no", { path: "/" });
            }else{
              setCookie("expiryDate", response.data.expiryDate, { path: "/" });
            }
          })
          .catch(function (error) {
            console.log("member info error");
            console.log(error);
          });
        apiHelper
          .getMemberProfile(cookies.token)
          .then(function (response) {
            var iconImage = response.data.iconImage ? response.data.iconImage : "";
            setCookie("profileIcon", iconImage, { path: "/" , domain: process.env.REACT_APP_HKIFF_DOMAIN || "cloud.udev.hk" });
          })
          .catch(function (error) {
            console.log("member profileIcon error");
            console.log(error);
        });
      } catch (e) {
        console.log(e);
      }
    }
  }, [cookies.token]);

  function getRenewalDiscount() {
    try {
      apiHelper
        .getPlanInfo(i18n.language, cookies.token)
        .then(function (response) {
          setDiscount(100 - response.data.renewalDiscount * 100);
        })
        .catch(function (error) {
          console.log(error);
        });
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    if (cookies.expiryDate) {
      setExDate(cookies.expiryDate);
      setUsername(cookies.firstName);
      getRenewalDiscount();

      var expiryDate = new Date(cookies.expiryDate);
      var oneMonthLater = new Date();
      oneMonthLater.setMonth(oneMonthLater.getMonth() + 1);
      var isEndSoon = expiryDate < oneMonthLater;
      var isExpired = expiryDate < getTodayWithoutTime();
      if (isEndSoon) {
        setIsEndSoon(isEndSoon);
      }
      if (isExpired) {
        setIsExpired(isExpired);
      }
      if (!isExpired) {
        var param = window.location.search.substr(1);
        var url = param.split("=");
        if(param != "" && url[0] == "redirect") {
          window.location.href = url[1];
        }else {
          history.push("/" + i18n.language + "/profile");
        }
      }
    }
  }, [cookies.expiryDate]);

  // Auto-logout after 5 seconds when membership is expired
  useEffect(() => {
    if (isExpired && cookies.expiryDate) {
      const logoutTimer = setTimeout(() => {
        // Remove all cookies to log out the user
        removeCookie('token', { path: '/' , domain: process.env.REACT_APP_HKIFF_DOMAIN || "cloud.udev.hk" });
        removeCookie('firstName', { path: '/' });
        removeCookie('lastName', { path: '/' });
        removeCookie('expiryDate', { path: '/' });
        removeCookie('profileIcon', { path: '/' , domain: process.env.REACT_APP_HKIFF_DOMAIN || "cloud.udev.hk" });

        // Reset expired state
        setIsExpired(false);
      }, 5000); // 5 seconds

      // Cleanup timer on unmount or when dependencies change
      return () => clearTimeout(logoutTimer);
    }
  }, [isExpired, cookies.expiryDate, removeCookie]);

  function toRenew() {
    history.push("/" + i18n.language + "/renew");
  }

  // function toProfile() {
  //   history.push("/" + i18n.language + "/profile");
  // }
  
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <Box className={classes.pageContainer}>
      <Box className={classes.container}>
        <LoginRegisterTabs active="login" />
        <Typography variant="h1">{t("title")}</Typography>
        <Typography variant="h2">{t("subtitle")}</Typography>

        <form onSubmit={handleSubmit(onSubmit)}>
          <Controller
            name="member_id"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <>
                <InputLabel htmlFor="member_id" variant="outlined">
                  {t("cineclubid")}
                </InputLabel>
                <TextField
                  id="member_id"
                  variant="outlined"
                  margin="dense"
                  className={classes.textInput}
                  placeholder={t("cineclubidplaceholder")}
                  fullWidth
                  {...field}
                  error={!!errorMessage.memberId || !!errorMessage.all}
                  helperText={errorMessage.memberId && t(errorMessage.memberId)}
                />
              </>
            )}
          />
          <Typography variant="h2" style={{ position: "relative"}}>
            <a className={classes.forget} onClick={()=>{setIsForget(true)}}>{t("forgotpassword")}</a>
          </Typography>
          <Controller
            name="password"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <>
                <InputLabel htmlFor="password" variant="outlined">
                  {t("password")}
                </InputLabel>
                <TextField
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  variant="outlined"
                  margin="dense"
                  className={classes.textInput}
                  placeholder={t("passwordplaceholder")}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position={"end"} onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}>
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </InputAdornment>
                    ),
                  }}
                  fullWidth
                  {...field}
                  error={!!errorMessage.password || !!errorMessage.all}
                  helperText={errorMessage.password && t(errorMessage.password)}
                />
              </>
            )}
          />

          <Button
            type="submit"
            className={classes.btn}
            variant="contained"
            fullWidth
          >
            {t("loginbtn")}
          </Button>
        </form>
        {/* <Typography variant="body1" align="center" gutterBottom="true">
          {" "}
          {t("notamember")}
          <Link className={classes.highlight} to={`/${i18n.language}/register`}>
            {t("joinnow")}
          </Link>{" "}
        </Typography> */}
      </Box>
      {(isExpired) && cookies.expiryDate ? (
        <Overlay>
          <Box className={classes.reminderBox}>
            {isExpired ? (
              <Typography variant="h2">
                {t("renewpopup.expiredsubtitle")}
              </Typography>
            ) : (
              <>
              </>
            )}
            {/*    <Typography variant="h1">*/}
            {/*      <Trans t={t} i18nKey="renewpopup.title">*/}
            {/*        {{ username }}, your membership plan will be end soon!*/}
            {/*      </Trans>*/}
            {/*    </Typography>*/}
            {/*    <Typography variant="h2">*/}
            {/*      <Trans t={t} i18nKey="renewpopup.subtitle">*/}
            {/*        <span*/}
            {/*          className={classes.highlight}*/}
            {/*          style={{ fontWeight: "bold" }}*/}
            {/*        >*/}
            {/*          {{ exDate }}*/}
            {/*        </span>*/}
            {/*      </Trans>*/}
            {/*    </Typography>*/}
            {/*  </>*/}
            {/*)}*/}

            {/* <Button
              type="button"
              className={classes.smallBtn}
              variant="contained"
              onClick={toRenew}
            >
              <Trans t={t} i18nKey="renewpopup.rejoinnow" />
            </Button> */}

      {/*      {!isExpired && (*/}
      {/*        <Button*/}
      {/*          type="button"*/}
      {/*          className={classes.smallBtn}*/}
      {/*          variant="outlined"*/}
      {/*          onClick={toProfile}*/}
      {/*        >*/}
      {/*          {t("renewpopup.later")}*/}
      {/*        </Button>*/}
      {/*      )}*/}
          </Box>
        </Overlay>
      ) : (
        <></>
      )}
      {isForget &&
        <ForgetPassword setIsForget={setIsForget}/>
      }
    </Box>
  );
}

export default LoginPage;
